// mDDP (modified Delivered Duty Paid Program) fragment for UsIor
export const mddpFragment = `
  fragment mddpFields on UsIor {
    vendorCodes
  }
`;
